import {Right} from './profile';

export class MenuItem {
  id: number;
  parentId: number;
  name: string;
  description: string;
  itemIcon: string;
  itemOrder: number;
  url: string;
  children: MenuItem[];
  requiredRights: number[];

}
